import React, { useState, useMemo } from "react";
import "../Home/theme.css"; // Import the CSS file
import toneblueg from "../../Assesst/laminance blue tone glossy.png";
import toneblue from "../../Assesst/laminance blue tone matte.png";
import CelestialBlue from "../../Assesst/laminance Celestial Blueglossy.png";
import CelestialBlueg from "../../Assesst/laminance Celestial Blue matee.png";
import pabblegrayg from "../../Assesst/Laminance Pabble grayG.png"
import pabblegray from "../../Assesst/Laminance Pabble grayM.png"
import Warmgrayg from "../../Assesst/Laminance Warm grayG .png"
import Warmgray from "../../Assesst/Laminance Warm grayM.png"
import Mossgrayg from "../../Assesst/Laminance Moss gray G.png"
import Mossgray from "../../Assesst/Laminance Moss gray M.png"
import Palegrayg from "../../Assesst/Laminance palegrayg.png"
import Palegray from "../../Assesst/Laminance palegraym.png"
import folkestonefrayg  from "../../Assesst/folkestonefrayg.png"
import folkestonefray from "../../Assesst/folkestonefraym.png"
import Platinum from "../../Assesst/Platinumgmm.png"
import Platinumg from "../../Assesst/Platinumgg.png"
import smokeg from "../../Assesst/smokeg.png"
import smoke from "../../Assesst/smoke.png"
import silvergrayg from "../../Assesst/silvergrayg.png"
import silvergray from "../../Assesst/silvergray.png"
import Ceramicg from "../../Assesst/Ceramicg.png"
import Ceramic from "../../Assesst/Ceramic.png"
import Champagneg from "../../Assesst/Champagneg.png"
import Champagne from "../../Assesst/Champagne.png"
import MysoreIvoryg from "../../Assesst/MysoreIvoryg.png"
import MysoreIvory from "../../Assesst/MysoreIvory.png"
import InteriorWhiteg from "../../Assesst/InteriorWhiteg.png"
import InteriorWhite from "../../Assesst/InteriorWhite.png"
import SnowWhiteg from "../../Assesst/SnowWhiteg.png"
import SnowWhite from "../../Assesst/SnowWhite.png"
import RoyalWhiteg from "../../Assesst/RoyalWhiteg.png"
import RoyalWhite from "../../Assesst/RoyalWhite.png"
import CandyWhiteg from "../../Assesst/CandyWhiteg.png"
import CandyWhite from "../../Assesst/CandyWhite.png"
import WhiteLilyg from "../../Assesst/WhiteLilyg.png"
import WhiteLily from "../../Assesst/WhiteLily.png"

const OrnaMatte = "/assets/Images/Ornamatte-brochure-3[1]_1.jpg";
const OrnaMatte2 = "/assets/Images/Ornamatte-brochure-3[1]_2.jpg";
const OrnaMatte3 = "/assets/Images/Ornamatte-brochure-3[1]_3.jpg";
const OrnaMatte4 = "/assets/Images/Ornamatte-brochure-3[1]_4.jpg";

const products = [
  { id: 36, name: "Ornamatte 1", category: "Ornamatte", img: OrnaMatte },
  { id: 37, name: "Ornamatte 2", category: "Ornamatte", img: OrnaMatte2 },
  { id: 38, name: "Ornamatte 3", category: "Ornamatte", img: OrnaMatte3 },
  { id: 39, name: "Ornamatte 4", category: "Ornamatte", img: OrnaMatte4 },

  { id: 1, name: "22212 Toned Blue-M", category: "Shaker", img: toneblue },
  { id: 2, name: "22212 Toned Blue-G", category: "Shaker", img: toneblueg },
  { id: 3, name: "21082 Celestial Blue-M", category: "Shaker", img: CelestialBlueg },
  { id: 4, name: "21082 Celestial Blue-G", category: "Shaker", img: CelestialBlue },
  { id: 5, name: "21369 Pebble Grey-M", category: "Shaker", img: pabblegray },
  { id: 6, name: "21369 Pebble Grey-G", category: "Shaker", img: pabblegrayg },
  { id: 7, name: "21029 Warm Grey-M", category: "Shaker", img: Warmgray },
  { id: 8, name: "21029 Warm Grey-G", category: "Shaker", img: Warmgrayg },
  { id: 9, name: "21109 Moss Grey-M", category: "Shaker", img: Mossgray },
  { id: 10, name: "21109 Moss Grey-G", category: "Shaker", img: Mossgrayg },
  { id: 11, name: "22169 Pale Grey-M", category: "Shaker", img: Palegray },
  { id: 12, name: "22169 Pale Grey-G", category: "Shaker", img: Palegrayg },
  { id: 13, name: "21019 Folkstone Grey-M", category: "Shaker", img: folkestonefray },
  { id: 14, name: "21019 Folkstone Grey-G", category: "Shaker", img: folkestonefrayg },
  { id: 15, name: "21059 Platinum-M", category: "Shaker", img: Platinum },
  { id: 16, name: "21059 Platinum-G", category: "Shaker", img: Platinumg },
  { id: 17, name: "21071 Smoke-M", category: "Shaker", img: smoke },
  { id: 18, name: "21071 Smoke-G", category: "Shaker", img: smokeg },
  { id: 19, name: "21069 Silver Grey-M", category: "Shaker", img: silvergray },
  { id: 20, name: "21069 Silver Grey-G", category: "Shaker", img: silvergrayg },
  { id: 21, name: "21161 Ceramic-M", category: "Shaker", img: Ceramic },
  { id: 22, name: "21161 Ceramic-G", category: "Shaker", img: Ceramicg },
  { id: 23, name: "21187 Champagne-M", category: "Shaker", img: Champagne },
  { id: 24, name: "21187 Champagne-G", category: "Shaker", img: Champagneg },
  { id: 25, name: "24087 Mysore Ivory-M", category: "Shaker", img: MysoreIvory },
  { id: 26, name: "24087 Mysore Ivory-G", category: "Shaker", img: MysoreIvoryg },
  { id: 27, name: "21341 Interior White-M", category: "Shaker", img: InteriorWhite },
  { id: 28, name: "21341 Interior White-G", category: "Shaker", img: InteriorWhiteg },
  { id: 29, name: "21141 Snow White-M", category: "Shaker", img: SnowWhite },
  { id: 30, name: "21141 Snow White-G", category: "Shaker", img: SnowWhiteg },
  { id: 31, name: "21581 Royal White-M", category: "Shaker", img: RoyalWhite },
  { id: 32, name: "21581 Royal White-G", category: "Shaker", img: RoyalWhiteg },
  { id: 33, name: "21941 Candy White-M", category: "Shaker", img: CandyWhite },
  { id: 34, name: "21941 Candy White-G", category: "Shaker", img: CandyWhiteg },
  { id: 35, name: "21081 White Lily-M", category: "Shaker", img: WhiteLily },
  { id: 36, name: "21081 White Lily-G", category: "Shaker", img: WhiteLilyg },
];

export default function EcommerceFilter() {
  const [search, setSearch] = useState("");
  const [fullscreenProduct, setFullscreenProduct] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [singleSelected, setSingleSelected] = useState(null);

  const categories = useMemo(() => [...new Set(products.map((p) => p.category))], []);

  const handleCategoryClick = (category) => {
    setSingleSelected((prev) => (prev === category ? null : category));
    setSidebarOpen(false);
  };

  const clearCategory = () => setSingleSelected(null);

  const filteredProducts = products.filter((p) => {
    const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
    const matchesSingle = singleSelected === null || p.category === singleSelected;
    return matchesSearch && matchesSingle;
  });

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Mobile Menu Button */}
      <button
        className="md:hidden p-4 text-white fixed top-20 left-4 z-40 rounded-lg shadow-lg"
        style={{
          backgroundColor: "var(--color-primary-500)",
        }}
        onClick={() => setSidebarOpen(true)}
        aria-label="Open menu"
      >
        ☰
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-[75px] left-0 h-full w-64 text-white p-6 shadow-lg transform transition-transform duration-300 z-40
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
        style={{
          backgroundColor: "var(--color-primary-500)",
        }}
      >
        <button
          className="absolute top-4 right-4 text-2xl font-bold md:hidden"
          onClick={() => setSidebarOpen(false)}
          style={{ color: "var(--color-white)" }}
          aria-label="Close menu"
        >
          ✕
        </button>

        <h2 className="text-4xl font-extrabold mb-6 text-center md:text-left tracking-wide bell-mt-primary" style={{ color: "var(--color-white)" }}>
          Styles
        </h2>

        <input
          type="text"
          placeholder="🔍 Search product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border text-black p-2 rounded-lg mb-6 focus:outline-none focus:ring-2 inter-secondary"
          style={{
            borderColor: "var(--border-light)",
          }}
        />

        <div className="space-y-3">
          {categories.map((category) => (
            <span
              key={category}
              onClick={() => handleCategoryClick(category)}
              className={`block cursor-pointer font-medium text-base sm:text-sm md:text-sm lg:text-lg truncate px-1 transition inter-secondary ${
                singleSelected === category ? "font-bold underline" : ""
              }`}
              style={{
                color: singleSelected === category ? "var(--color-accent-500)" : "var(--color-white)",
              }}
            >
              {category}
            </span>
          ))}
        </div>
      </div>

      {/* Products Grid */}
      <div className="flex-1 md:ml-64 p-8 overflow-y-auto" style={{ backgroundColor: "var(--color-gray-50)" }}>
        <h1 className="text-5xl md:text-7xl font-semibold text-center mb-6 p-5 tracking-wide bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
          Our Brochure
        </h1>

        {/* Active Filter Display */}
        {singleSelected && (
          <div className="flex justify-center mb-6">
            <div 
              className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
              style={{
                backgroundColor: "var(--color-primary-100)",
                color: "var(--color-primary-700)",
              }}
            >
              <span className="font-bold">{singleSelected}</span>
              <button
                onClick={clearCategory}
                className="text-lg font-bold transition hover:opacity-70"
                style={{ color: "var(--color-primary-700)" }}
                aria-label="Clear filter"
              >
                ✕
              </button>
            </div>
          </div>
        )}

        {/* Products List */}
        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
            {filteredProducts.map((p) => (
              <div
                key={p.id}
                className="w-full md:w-[75%] cursor-pointer flex flex-col items-center bg-white rounded-xl shadow-lg transition transform hover:-translate-y-1 overflow-hidden mx-auto hover:shadow-2xl"
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: p.category === "Ornamatte" 
                    ? "0 0 0 4px var(--color-primary-500), 0 20px 25px -5px rgba(0,0,0,0.1)" 
                    : "var(--shadow-medium)",
                }}
                onClick={() => setFullscreenProduct(p)}
              >
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-auto max-h-[75vh] object-contain rounded-md"
                />
                <p
                  className="text-xl font-bold py-4 text-center bell-mt-primary"
                  style={{
                    color: p.category === "Ornamatte" ? "var(--color-primary-600)" : "var(--color-gray-900)",
                  }}
                >
                  {p.name}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg text-center pt-20 inter-secondary" style={{ color: "var(--color-gray-600)" }}>
            No products found
          </p>
        )}
      </div>

      {/* Fullscreen Modal - Centered Image Without Name */}
      {fullscreenProduct && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
          onClick={() => setFullscreenProduct(null)}
        >
          <button
            className="absolute top-6 right-6 text-4xl font-bold transition hover:opacity-70 z-50"
            style={{ color: "var(--color-white)" }}
            onClick={(e) => {
              e.stopPropagation();
              setFullscreenProduct(null);
            }}
            aria-label="Close fullscreen view"
          >
            ✕
          </button>
          <div 
            onClick={(e) => e.stopPropagation()}
            className="flex items-center justify-center w-full h-full"
          >
            <img
              src={fullscreenProduct.img}
              alt={fullscreenProduct.name}
              loading="lazy"
              className="max-h-[90%] max-w-[90%] object-contain rounded-xl shadow-xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}